import React, { useState, useRef, useEffect } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { FieldWrapper } from '@progress/kendo-react-form';
import { Upload } from "@progress/kendo-react-upload";

export default function ImportDialog(props) {

	const { label, okCallback, cancelCallback } = props;
	const title = label + ' Import';
	const [filename, setFilename] = useState();
	const focusRef = useRef();
	
	useEffect(() => {
		focusRef.current.focus();
	}, []);	
	
	const filenameChanged = (event) => {
		setFilename(event.response.response.message);
	};

	return (
		<Dialog title={title} onClose={cancelCallback}>
	    	<div
	        	style={{
	            	margin: "0",
	              	textAlign: "left",
	            }}
			>
			<FieldWrapper className="constituo-field-wrapper">
				<Upload batch={false} multiple={false} defaultFiles={[]} withCredentials={true}
					autoUpload={true}
					restrictions={{ allowedExtensions: [".csx"]  }}
					saveField='file'
					onStatusChange={filenameChanged}	
					saveUrl={API_URL + '/api/file/upload?filename=placeholder.csx'}				
				/>
			</FieldWrapper>	
			</div>
	        <DialogActionsBar>
        		<button
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              		onClick={ () => { okCallback(filename); } }
            	>
            		OK
            	</button>
	           	<button
	           		ref={focusRef}
	           		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
	           		onClick={cancelCallback}
	           	>
	           		Cancel
	           	</button>
	        </DialogActionsBar>
		</Dialog>
	);
}